import { Alert } from '@mui/material'
import { CustomContentProps, SnackbarContent } from 'notistack'
import React from 'react'

export const CustomSnackbar = React.forwardRef<HTMLDivElement, CustomContentProps>((props, ref) => (
  <SnackbarContent ref={ref} role="alert">
    {props.variant === 'default' ? props.message : <Alert severity={props.variant}>{props.message}</Alert>}
  </SnackbarContent>
))
CustomSnackbar.displayName = 'CustomSnackbar'
